/* src/app/addons/incident/incident-list.component.css */
/*# sourceMappingURL=incident-list.component-SEALMDKA.css.map */
